'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { cn } from '@/utils/cn-tw-merge';
import { Link } from '@/components/ui/link/link.component';
import { formatToTitleCase } from '@/utils/formatters/format-to-title-case';
import { Card } from '@/components/ui/card.component';
import { IndexItem } from '@/types/index/index-list.type';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface SpecialtyUfCardProps {
  specialty: IndexItem;
  filterTerm?: string;
  isFirst?: boolean;
}

export function SpecialtyUfCard({
  specialty,
  filterTerm,
  isFirst = false,
}: SpecialtyUfCardProps) {
  const term = (filterTerm ?? '').trim().toLowerCase();
  const cities = term
    ? (specialty?.cities ?? []).filter(
        (city) =>
          city?.city?.toLowerCase().includes(term)
          || city?.slug?.toLowerCase().includes(term)
          || city?.state_abbr?.toLowerCase().includes(term),
      )
    : (specialty?.cities ?? []);

  return (
    <Card
      key={specialty.key}
      className={cn(
        'md:mt-6 pt-0 border-x-0 sm:px-16 md:px-6',
        'rounded-none md:rounded-xl',
        isFirst ? 'border-t' : 'border-t-0',
        'md:border-t md:border-b md:border-x',
      )}
    >
      <ul className="mt-4 space-y-4">
        {cities.length > 0
          ? cities.map((city, index) => (
              <li key={city?.slug}>
                <Link
                  prefetch={false}
                  href={`/especialidades/${specialty?.slug}-em-${city?.slug}/`}
                  data-testid={DataTestIdEnum.INDEXING_CARD_CITY_NAME}
                  className="text-green-500 font-bold hover:underline"
                  data-analytics-event={AnalyticsEnum.CLICK_SPECIALTY_BY_CITY}
                  data-analytics-properties={JSON.stringify({
                    especialidade: specialty.name,
                    cidade: city?.city,
                    estado_nome: city?.state_abbr,
                  })}
                >
                  {`${formatToTitleCase(String(specialty?.name))} em ${city?.city} - ${city?.state_abbr}`}
                </Link>
                {index !== cities.length - 1 && (
                  <hr className="mt-4" />
                )}
              </li>
            ))
          : (
              term
                ? (
                    <li>
                      <p className="text-gray-600" role="status">
                        Nenhuma cidade encontrada para o filtro informado.
                      </p>
                    </li>
                  )
                : null
            )}
      </ul>
    </Card>
  );
}
